import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationAddress2Page } from './update-registration-address2';

@NgModule({
  declarations: [
    UpdateRegistrationAddress2Page,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationAddress2Page),
  ],
  exports: [
    UpdateRegistrationAddress2Page
  ]
})
export class UpdateRegistrationAddress2PageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-address2/update-registration-address2.module.ts